import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { Carousel } from "react-responsive-carousel";
import { itemsFetch } from "../actions";
import LoadingPage from "./LoadingPage";
import { firebase } from "../firebase/firebase";

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      description: "",
      image: "",
      edit: false,
      id: null,
    };
    props.itemsFetch();
  }

  onOpenModal(item) {
    this.setState({
      open: true,
      image: item[1].image,
      description: item[1].description,
      id: item[0],
    });
  }

  onCloseModal() {
    this.setState({ open: false });
  }

  renderItems(items) {
    return Object.entries(items).map((item, i) => (
      <li key={i} onClick={() => this.onOpenModal(item)}>
        <div className="rig-cell">
          <img className="rig-img rig2-img" src={item[1].image} />
          <span className="rig-overlay" />
          <span className="rig-text">{item[1].description}</span>
        </div>
      </li>
    ));
  }

  render() {
    const { open, description, image, edit, id } = this.state;
    const { items } = this.props;
    if (items) {
      return (
        <div>
          <Carousel autoPlay infiniteLoop swipeable>
            <div>
              <img
                style={{ maxHeight: 600, objectFit: "contain" }}
                src="https://firebasestorage.googleapis.com/v0/b/jozsef-images-webpage.appspot.com/o/Items%2Fc5f18111-5f0a-74d8-f5c4-e40aba5b9cd9?alt=media&token=df98fc5c-4251-4657-a9a8-b69a54a79a33"
              />
              <p className="legend">Photo by: Helios</p>
            </div>
            <div>
              <img
                style={{ maxHeight: 600, objectFit: "contain" }}
                src="https://firebasestorage.googleapis.com/v0/b/jozsef-images-webpage.appspot.com/o/Items%2Fbc0db8fe-5583-5d44-031a-6c06771209be?alt=media&token=d57a476d-4a9f-4994-9129-d6afc6de8210"
              />
              <p className="legend">Photo by: Helios</p>
            </div>
            <div>
              <img
                style={{ maxHeight: 600, objectFit: "contain" }}
                src="https://firebasestorage.googleapis.com/v0/b/jozsef-images-webpage.appspot.com/o/Items%2Fdfd6fd10-8b71-d434-757b-a70ded5832de?alt=media&token=cb2bd4ce-daaa-4215-bfd1-21780e196841"
              />
              <p className="legend">Photo by: Helios</p>
            </div>
            <div>
              <img
                style={{ maxHeight: 600, objectFit: "contain" }}
                src="https://firebasestorage.googleapis.com/v0/b/jozsef-images-webpage.appspot.com/o/Items%2Fda24b802-6a54-258c-5524-54fc953cd269?alt=media&token=0d9d9f26-e4e0-42b6-b9f8-874e69a0befd"
              />
              <p className="legend">Photo by: Helios</p>
            </div>
            <div>
              <img
                style={{ maxHeight: 600, objectFit: "contain" }}
                src="https://firebasestorage.googleapis.com/v0/b/jozsef-images-webpage.appspot.com/o/Items%2Fd70373bf-0143-db49-4b50-b837633691cd?alt=media&token=111e3e80-2787-4956-94bc-5050a0705701"
              />
              <p className="legend">Photo by: Zehnder</p>
            </div>
          </Carousel>
          <ul id="rig" className="rig2">
            {this.renderItems(items)}
          </ul>
          <Modal open={open} onClose={() => this.onCloseModal()} center>
            <img style={{ maxWidth: "calc(800px - 2.4rem)" }} src={image} />

            {edit ? (
              <textarea
                style={{ width: "100%" }}
                onChange={e => this.setState({ description: e.target.value })}
                value={description}
              />
            ) : (
              <div style={{ whiteSpace: "pre" }}>{description}</div>
            )}
            {edit ? (
              <div>
                <button
                  onClick={() => {
                    this.onCloseModal();
                    this.setState({ edit: false });
                  }}>
                  Mégse
                </button>
                <button
                  onClick={() =>
                    firebase
                      .database()
                      .ref("Item")
                      .child(id)
                      .update({ description })
                      .then(() => {
                        alert("Szerkesztve!");
                        location.reload();
                      })
                  }>
                  Mentés
                </button>
              </div>
            ) : (
              <button
                style={{ display: this.props.uid ? "initial" : "none" }}
                onClick={() => this.setState({ edit: true })}>
                Szerkesztés
              </button>
            )}
          </Modal>
        </div>
      );
    } else {
      return <LoadingPage />;
    }
  }
}
const mapStateToProps = state => {
  return {
    items: state.fetch.items,
    uid: state.auth.uid,
  };
};

export default connect(
  mapStateToProps,
  { itemsFetch }
)(HomePage);



// WEBPACK FOOTER //
// ./src/components/HomePage.js